//import moment from "moment/moment";

export default function useIsLearnyDays() {
    /*const start = moment('2026-03-09T00:00:00.000Z');
    const end = moment('2026-03-15T23:59:59.999Z');
    const now = moment();
    return now.isBetween(start, end);*/
    return false;
}